import { Action } from '../../../common/actions/core/action';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../../common/actions/core/action-handler';
import { GoToOffersAction } from './go-to-offers-dialog.action';
import StorageService from '../../services/storage.service';
import NoAuthPackagesService from '../../services/noauth-packages.service';

/* @ngInject */
export default class GoToOffersDialogController implements ActionHandler {
  private msisdn: string;
  private dialogElement;
  private title = "noAuth.otp.offers.default.title";
  private text = "noAuth.otp.offers.default.text";

  constructor(
    private $element,
    private $window,
    private $state,
    private storageService: StorageService,
    private actionDispatcher: ActionDispatcherService,
    private noAuthPackagesService: NoAuthPackagesService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#go-to-offers-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof GoToOffersAction) {
      this.msisdn = action.msisdn;
      if (action.reason) {
        if (action.reason === "hasPackage") {
          this.title = "noAuth.otp.offers.hasPackage.title";
          this.text = "noAuth.otp.offers.hasPackage.text";
        } else if (action.reason === "purchased") {
          this.title = "noAuth.otp.offers.purchased.title";
          this.text = "noAuth.otp.offers.purchased.text";
        }
      }
      this.openDialog();
    }
  }

  public async onClick() {
    await this.noAuthPackagesService.checkUser(this.msisdn);
    this.dialogElement.close();
    this.storageService.setMsisdn(this.msisdn);
    this.$state.go('noAuthOffers');
    this.$window.scrollTo(0, 0);
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
    this.dialogElement.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/go-to-offers-dialog/go-to-offers-dialog.controller.ts